<template>
    <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
        <td class="no_padding drag_drop"><span></span></td>
      <td class="no_padding">
        <span
            v-if="!$_updateActionAllowed"
            class="lock"
            :title="'Globální carousel. Nelze editovat' | translate"
            v-translate>
			</span>
        <input
            type="checkbox"
            :id="entity.id"
            :value="entity.id"
            @click.stop
            @change="onChange"
            :checked="isChecked"
        />
        <label :for="entity.id" @click.stop v-translate>Vybrat</label>
      </td>
      <span class="lock" v-if="!$_updateActionAllowed" :title="'Globální carousel. Nelze editovat' | translate" v-translate>Zamčeno</span>
      <td :data-th="'Název' | translate" class="first_data">
        <strong>{{ entity.name }}</strong>
      </td>
        <td :data-th="'Operátor' | translate" v-if="$_loggedUser_selectedOperatorId">{{ entity.operator_name }}</td>
        <td :data-th="'Typ výpisu' | translate">{{ showVariantText }}</td>
        <td :data-th="'Typ carouselu' | translate">{{ typeText }}</td>
        <td :data-th="'Počet položek' | translate">{{ entity.dashboard_items_count}}</td>
        <td :data-th="'Váha' | translate">{{ entity.weight}}</td>
        <td :data-th="'Tématická skupina' | translate">
                  <span :key="entity.thematic_group_id">
          <a class="link" @click.stop.prevent="openThematicGroupDetail(entity.thematic_group_id)">{{entity.thematic_group_name}}</a>
        </span>
        </td>
      <td :data-th="'Vloženo' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
      <td :data-th="'Upraveno' | translate" v-html="$_date_formatFull(entity.date_updated)"></td>

      <td class="no_padding edit">
            <div class="edit_inner" v-if="deletable">
                <a
            v-if="$_deleteActionAllowed && !isOperatorEditGlobal"
						class="btn btn_action btn_delete"
						:title="'Smazat' | translate"
						@click.prevent.stop="emitDeleteEntity"
						v-translate>Smazat
				</a>
              <a
                  v-if="$_deleteActionAllowed && isOperatorEditGlobal && entity.is_overriden"
                  class="btn btn_action btn_reset"
                  :title="'Resetovat' | translate"
                  @click.prevent.stop="emitDeleteEntity"
                  v-translate>Smazat
              </a>
            </div>
        </td>
    </tr>
</template>

<script>
	import rowActions from "@/components/mixins/row-actions"

	export default {
		name: "DashboardCarouselRow",
		mixins: [rowActions],
		data() {
			return {
				moduleName: 'dashboardCarousels',
				detailPageRouteName: 'dashboardCarouselDetail',
			}
		},
		computed: {
      isOperatorEditGlobal(){
        return this.entity.global && this.$_loggedUser_selectedOperatorId
      },
			deletable() {
				return this.$_deleteActionAllowed;
			},
      showVariantText(){
        if(this.entity.type !== 'channels') {
          switch (this.entity.show_variant) {
            case 'WIDE':
              return this.$gettext("Obrázky na šířku");
            case 'PORTRAIT':
              return this.$gettext("Plakáty na výšku");
            case 'ULTRA_WIDE':
              return this.$gettext("Extra široké položky");
            case 'BACKGROUND':
              return this.$gettext("Pozadí");
            case 'TOP_10':
              return this.$gettext("Top 10");
            default:
              return this.$gettext("Neznámý typ výpisu");
          }
        }else{
          return '';
        }
      },
      typeText(){
        switch (this.entity.type){
          case 'tips':
            return this.$gettext('Tipy');
          case 'best_rated':
            return this.$gettext('Nejlépe hodnocené');
          case 'last_viewed':
            return this.$gettext('Naposledy zhlédnuté pořady');
          case 'pvrs':
            return this.$gettext('Nahrávky');
          case 'tags':
            return this.$gettext('Štítky');
          case 'favorites':
            return this.$gettext('Oblíbené');
          case 'periodic_pvrs':
            return this.$gettext('Periodické nahrávky');
          case 'custom':
            return this.$gettext('Obsahový carousel');
          case 'selected_broadcasts':
            return this.$gettext('Obsahový carousel - vysílání');
          case 'selected_shows':
            return this.$gettext('Obsahový carousel - pořady');
          case 'channels':
            return this.$gettext('Kanálový carousel');
          case 'last_channels':
            return this.$gettext('Naposledy zhlédnuté kanály');
          case 'menu':
            return this.$gettext('Menu');
          case 'most_viewed_broadcast':
            return this.$gettext('Nejsledovanější pořady');
          case 'top_10_movies':
            return this.$gettext('Top 10 filmů')
          case 'top_10_series':
            return this.$gettext('Top 10 seriálů')
          default:
            return this.$gettext('Neznámý typ');
        }
      }
		},
    methods: {
      openThematicGroupDetail(idThematicGroup) {
        this.$router.push({
          name: 'thematicGroupDetail',
          params: {
            id: idThematicGroup
          }
        });
      },
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/views/dashboardCarousels/DashboardCarouselRow.vue